var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 22,
    viewBox: "0 0 122 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4263 1.43066H32.9297V20.5943H38.4263V1.43066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3903 11.6414L46.6963 1.43066H42.1741V20.5943H47.5708V10.3836L57.2398 20.5943H61.762V1.43066H56.3903V11.6414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.261 5.72214H69.2323V20.5943H74.7039V5.72214H80.6503V1.43066H63.261V5.72214Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.405 1.43043H108.009L100.164 18.9663L97.1155 14.5515C98.3397 13.9596 99.2641 13.1703 99.9387 12.1345C100.588 11.0986 100.913 9.89007 100.913 8.5089C100.913 7.07841 100.563 5.82056 99.8638 4.73536C99.1642 3.67482 98.1648 2.83626 96.8656 2.26899C95.5664 1.70173 94.0423 1.40576 92.2934 1.40576H82.1497V20.5694H87.6463V15.4887H91.9187L95.4415 20.5694H99.439H101.288H105.036L106.56 16.8452H114.755L116.279 20.5694H122L113.405 1.43043ZM94.5171 10.5807C93.9424 11.0739 93.0929 11.2959 91.9686 11.2959H87.6463V5.69724H91.9686C93.0929 5.69724 93.9424 5.94388 94.5171 6.43715C95.0917 6.93043 95.3665 7.62101 95.3665 8.5089C95.3665 9.39679 95.0917 10.0874 94.5171 10.5807ZM108.184 12.8744L110.682 6.73312L113.181 12.8744H108.184Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0932 0C10.9682 0 10.6934 0 10.4436 0L7.34546 5.72197H14.4411L17.5392 11.1973L14.4661 16.9193H7.74521L10.8433 22C10.9682 22 10.9682 22 11.0932 22C17.2893 22 22.3113 17.1659 22.3113 11.074C22.3113 4.9574 17.2644 0 11.0932 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52099 16.2287H14.0414L16.7397 11.1974L14.0414 6.4126L11.2181 11.1974H0C0 16.7713 4.44727 21.4328 9.99386 21.9507L6.52099 16.2287Z",
    fill: "#EC6A06"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntra);
export default __webpack_public_path__ + "static/media/Intra.ac147bff560a094dd790c23d062e9bc4.svg";
export { ForwardRef as ReactComponent };